<template>
  <component
    :is="divOrLink"
    :to="to"
    v-bind="$attrs"
    class="button"
    :id="id"
    :data-cy="disabled ? elementName + '-disabled' : elementName"
    :class="[
      buttonClass,
      !flat ? 'waves-effect waves-light' : '',
      extraClasses,
      loading ? 'button--no-click' : '',
      small ? 'button--small' : '',
      danger && !disabled ? 'button--danger' : '',
      safe ? 'button--safe' : '',
      primary ? 'button--primary' : '',
      transparent ? 'button--transparent' : '',
      flat ? 'button--flat' : '',
      flat && dark ? 'button--flat-dark' : '',
      disabled ? 'button--disabled' : '',
      loading ? 'button--loading' : '',
      shadow ? 'button--shadow' : ''
    ]"
  >
    <i
      class="loading-spinner left"
      v-show="loading"
      :class="{
        'loading-spinner--white': whiteSpinner
      }"
    ></i>
    <template v-if="!loading">
      <i v-if="icon" class="mdi" :class="[{ left: text }, icon]"></i>
    </template>
    <slot></slot>
  </component>
</template>

<script>
export default {
  props: {
    to: {
      default: null,
      required: false
    },
    extraClasses: {
      default: null,
      required: false
    },
    elementName: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: null,
      required: false
    },
    loading: {
      type: Boolean
    },
    small: {
      type: Boolean
    },
    danger: {
      type: Boolean
    },
    primary: {
      type: Boolean
    },
    safe: {
      type: Boolean
    },
    transparent: {
      type: Boolean
    },
    flat: {
      type: Boolean
    },
    dark: Boolean,
    id: {
      type: String
    },
    disabled: Boolean,
    color: {
      type: String
    },
    shadow: Boolean
  },
  computed: {
    buttonClass() {
      return `button--${this.color}` || '';
    },
    text() {
      return !!this.$slots.default;
    },
    whiteSpinner() {
      return (
        this.danger ||
        this.safe ||
        this.color === 'blue' ||
        this.color === 'green' ||
        this.color === 'grey' ||
        this.primary
      );
    },
    divOrLink() {
      return this.to ? 'router-link' : 'div';
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
.button {
  padding: 10px 20px;
  text-align: center;
  border-radius: 30px;
  background-color: #fff;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 1.2px;
  display: inline-block;
  color: #000;
  cursor: pointer;
  transition: padding 0.1s ease-in;
  display: inline-flex;
  align-items: center;

  &:hover {
    background-color: rgba(255, 255, 255, 0.8);
  }

  .mdi {
    font-size: 20px !important;
    line-height: 20px !important;
    margin-right: 5px !important;
  }

  svg {
    margin-left: 3px;
  }

  &--small {
    padding: 7px 15px;
    border-radius: 17px;
  }

  &--disabled {
    opacity: 0.4;
    pointer-events: none !important;
  }

  &--danger {
    background-color: $symptoms-red;
    color: #fff;
    &:hover {
      background-color: darken($symptoms-red, 5%);
    }
  }

  &--warning {
    background-color: $symptoms-orange;
    color: #fff;
    &:hover {
      background-color: darken($symptoms-orange, 5%);
    }
  }

  &--flat {
    background-color: transparent;
    color: #fff;
    // padding: 10px 0;
    &-dark {
      color: #000;
    }
    &:hover {
      background-color: transparent;
    }
  }

  &--blue,
  &--primary {
    background-color: $symptoms-blue;
    color: #fff;
    &:hover {
      background-color: darken($symptoms-blue, 5%);
    }
  }

  &--border {
    border: 1px solid #bbb;
    color: #bbb;
    &-blue {
      border: 1px solid $symptoms-blue;
    }
  }

  &--transparent {
    background-color: transparent;
    border: 1px solid rgb(187, 216, 228);
    color: rgb(187, 216, 228);
    padding: 14px 20px;
  }

  &--safe,
  &--green {
    background-color: $symptoms-green;
    color: #fff;
    &:hover {
      background-color: darken($symptoms-green, 5%);
    }
  }
  &--grey {
    background-color: lighten($symptoms-grey, 10%);
    color: lighten($symptoms-grey, 30%);
    &:hover {
      background-color: darken($symptoms-grey, 5%);
      color: lighten($symptoms-grey, 50%);
    }
  }

  &--no-click {
    pointer-events: none;
  }

  &--shadow {
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
  }

  & ~ * {
    margin-left: 10px;
  }
}
</style>
